import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import FlexGrid from '@tds/core-flex-grid';
import Input from '@tds/core-input';
import Button from '@tds/core-button';
import Notification from '@tds/core-notification';
import Strong from '@tds/core-strong';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const AddInfoForm = ({ vehicleInfo, setVehicleInfo }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: {
      vehicleInfoMessage,
      vehicleVIN,
      vehicleMake,
      vehicleModel,
      vehicleYear,
      vehicleQuantity
    }
  } = localizedStrings;

  const [dataField, setDataFields] = useState({
    vin: '',
    make: '',
    model: '',
    year: '',
    quantity: ''
  });
  const [error, setError] = useState('');

  const onAddVehicleInfo = () => {
    if (
      !(
        dataField.vin ||
        (dataField.make && dataField.model && dataField.year)
      ) ||
      !dataField.quantity
    ) {
      setError('Please enter all necessary information');
      return;
    }
    setVehicleInfo([...vehicleInfo, dataField]);
    setDataFields({
      vin: '',
      make: '',
      model: '',
      year: '',
      quantity: ''
    });
    setError('');
  };

  return (
    <Box between={3}>
      <Notification variant="branded" copy="en">
        <Strong>Note: </Strong>
        {vehicleInfoMessage}
      </Notification>
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col>
            <Input
              label={vehicleVIN}
              value={dataField.vin}
              onChange={e =>
                setDataFields({ ...dataField, vin: e.target.value })
              }
            />
          </FlexGrid.Col>
          <FlexGrid.Col>
            <Input
              label={vehicleMake}
              value={dataField.make}
              onChange={e =>
                setDataFields({ ...dataField, make: e.target.value })
              }
            />
          </FlexGrid.Col>
          <FlexGrid.Col>
            <Input
              label={vehicleModel}
              value={dataField.model}
              onChange={e =>
                setDataFields({ ...dataField, model: e.target.value })
              }
            />
          </FlexGrid.Col>
          <FlexGrid.Col>
            <Input
              label={vehicleYear}
              pattern="[0-9]{4}"
              maxLength="4"
              value={dataField.year}
              onChange={e =>
                setDataFields({ ...dataField, year: e.target.value })
              }
            />
          </FlexGrid.Col>
          <FlexGrid.Col>
            <Input
              label={vehicleQuantity}
              pattern="[0-9]"
              value={dataField.quantity}
              onChange={e =>
                setDataFields({ ...dataField, quantity: e.target.value })
              }
            />
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
      <Box vertical={3} horizontal={3}>
        <Button onClick={onAddVehicleInfo}>Add</Button>
      </Box>
      {error && (
        <Notification
          variant="error"
          dismissible
          onExit={() => setError('')}
          copy="en"
        >
          {error}
        </Notification>
      )}
    </Box>
  );
};

AddInfoForm.propTypes = {
  vehicleInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
  setVehicleInfo: PropTypes.func.isRequired
};

export default AddInfoForm;
